import axios from "axios";
import {
  SHARED_ADD_ANNOUNCEMENT_FAIL,
  SHARED_ADD_ANNOUNCEMENT_REQUEST,
  SHARED_ADD_ANNOUNCEMENT_SUCCESS,
  SHARED_DELETE_ANNOUNCEMENT_FAIL,
  SHARED_DELETE_ANNOUNCEMENT_REQUEST,
  SHARED_DELETE_ANNOUNCEMENT_SUCCESS,
  SHARED_GET_ANNOUNCEMENT_FAIL,
  SHARED_GET_ANNOUNCEMENT_REQUEST,
  SHARED_GET_ANNOUNCEMENT_SUCCESS,
} from "../../types/shared/authTypes";

//ADD ANNOUNCEMENT
export const addAnnouncedAction =
  (formData, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: SHARED_ADD_ANNOUNCEMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.token) {
        sharedUser = sharedUserInfo?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: sharedUser,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/announce/add`,
        formData,
        config
      );
      dispatch({
        type: SHARED_ADD_ANNOUNCEMENT_SUCCESS,
        payload: data?.message,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: SHARED_ADD_ANNOUNCEMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//DELETE ANNOUNCEMENT
export const deleteAnnouncedAction =
  (announceId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: SHARED_DELETE_ANNOUNCEMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.token) {
        sharedUser = sharedUserInfo?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: sharedUser,
        },
      };

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/announce/${announceId}/delete`,
        config
      );
      dispatch({
        type: SHARED_DELETE_ANNOUNCEMENT_SUCCESS,
        payload: data?.message,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: SHARED_DELETE_ANNOUNCEMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET ANNOUNCEMENT
export const getAnnouncedAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: SHARED_GET_ANNOUNCEMENT_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    let sharedUser = "";
    if (sharedUserInfo?.token) {
      sharedUser = sharedUserInfo?.token;
    } else {
      sharedUser = sharedUserInfo?.payload?.token;
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: sharedUser,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/announce/all/data`,
      config
    );
    dispatch({
      type: SHARED_GET_ANNOUNCEMENT_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: SHARED_GET_ANNOUNCEMENT_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
